/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-social-icons.html";

import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg";
import twitter from "../assets/twitter.svg";
import pinterest from "../assets/pinterest.svg";

/**
 * The ns-social-icons should be used for
 *
 * <h1>Social Icons</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-social-icons></ns-social-icons>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsSocialIcons extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-social-icons";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      baseUrl: {
        type: String,
        value: "https://test.mynuskin.com"
      },
      socialMediaList: {
        type: Array,
        value: [
          {
            socialIconType: "facebook",
            socialIconUrl: facebook,
            socialIconLink: "https://facebook.com/nuskin"
          },
          {
            socialIconType: "instagram",
            socialIconUrl: instagram,
            socialIconLink: "https://instagram.com/nuskin"
          },
          {
            socialIconType: "twitter",
            socialIconUrl: twitter,
            socialIconLink: "https://twitter.com/nuskin"
          },
          {
            socialIconType: "pinterest",
            socialIconUrl: pinterest,
            socialIconLink: "https://pinterest.com/nuskin"
          }
        ]
      },
      socialMediaHeaderText: {
        type: String,
        value: "CONNECT WITH NU SKIN"
      },
      expandbreakpoint: String
    };
  }

  ready() {
    super.ready();
  }
}
customElements.define(NsSocialIcons.is, NsSocialIcons);
